export type VideoType = 'youtube' | 'vimeo' | 'embed' | 'unknown';

export type VideoInfo = {
  width: number;
  height: number;
  duration: number;
  thumbnailUrl: string;
  title: string;
  uploadDate: string;
};

export const getVideoType = (video: string): VideoType => {
  if (!video || video === '') {
    return 'unknown';
  }
  const videoTemp = video.toLowerCase();

  if (videoTemp.includes('youtube.') || videoTemp.includes('youtu.be')) {
    return 'youtube';
  }
  if (videoTemp.includes('vimeo.')) {
    return 'vimeo';
  }
  if (
    videoTemp.includes('.mp4') ||
    videoTemp.includes('.ogg') ||
    videoTemp.includes('.webm') ||
    videoTemp.includes('s3-')
  ) {
    return 'embed';
  }
  return 'unknown';
};

export const getVideoInfo = async (
  videoUrl: string,
): Promise<VideoInfo | null> => {
  let oembedUrl = '';
  const videoType = getVideoType(videoUrl);

  if (videoType === 'youtube') {
    oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(videoUrl)}&format=json`;
  } else if (videoType === 'vimeo') {
    oembedUrl = `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`;
  } else {
    return null;
  }

  try {
    const response = await fetch(oembedUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch video info: ${response.status}`);
    }

    const data = await response.json();
    const {
      width,
      height,
      duration,
      thumbnail_url: thumbnailUrl,
      upload_date: uploadDate,
      title,
    } = data;
    return {
      width,
      height,
      duration,
      thumbnailUrl,
      title,
      uploadDate,
    };
  } catch {
    return null;
  }
};

export const formatDuration = (seconds: number): string => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

export const isPlaylistLink = (url: string): boolean => {
  return /(?:youtube\.com|youtu\.be).*[?&]list=/i.test(url);
};

export const isVideoLink = (url: string): boolean => {
  if (isPlaylistLink(url)) {
    return false;
  }
  return (
    /(?:youtube\.com|youtu\.be|vimeo\.com)/i.test(url) ||
    /\.(mp4|webm|ogg)$/i.test(url)
  );
};
